import { createStore } from 'satcheljs';
import { IAppealStateState } from './schema/IAppealState';

export const getAppealStore = createStore<IAppealStateState>('AppealState', {
  documentUploadStatus: [],
  isDocumentUploadPanelOpen: false,
});
